import { CoreService } from 'src/app/core/services/core.service';
import { Router } from '@angular/router';
import { ADMIN_ANNUAL_REPORTING_DASHBOARD_URL, REPORTING_WORKFLOWS_URL, WORKFLOWS_DASHBOARD, WORKFLOWS_DASHBOARD_URL, WORKFLOW_DASHBOARD_KEY } from './../../constants/constant';
import { Component, OnInit } from '@angular/core';
import { ReportingYearsService } from 'src/app/core/services/reporting-years.service';

@Component({
  selector: 'app-view-progress-tracker-btn',
  templateUrl: './view-progress-tracker-btn.component.html',
  styleUrls: ['./view-progress-tracker-btn.component.scss']
})
export class ViewProgressTrackerBtnComponent implements OnInit {

  dashboardName = WORKFLOWS_DASHBOARD;
  showProgressTracker: boolean;
  currentReportingCycleYear: string;
  disableButton = false;
  selectedReportingCycleYear: any;

  constructor(private router: Router,
    private coreService: CoreService,
    private reportingYearsService: ReportingYearsService) {
      this.currentReportingCycleYear = sessionStorage.getItem('currentReportingCycleYear');
     }

  ngOnInit(): void {
    let options: any;
    if (!this.coreService.menus) {
      options = this.coreService.getHemburgerMenus();
    } else {
      options = this.coreService.menus;
    }
    if (options && options.length) {
      for (const menu of options) {
        const urlIndex = menu.subMenus.findIndex(x => x.key === WORKFLOW_DASHBOARD_KEY);
        if (urlIndex > -1) {
          this.showProgressTracker = true;
          break;
        }
      }
    }
    this.getReportingYear();
  }

  goToWorkflowDashboard(): void {
    if (this.router.url.indexOf(REPORTING_WORKFLOWS_URL) > -1) {
      this.router.navigateByUrl(ADMIN_ANNUAL_REPORTING_DASHBOARD_URL);
    } else {
      this.router.navigateByUrl(WORKFLOWS_DASHBOARD_URL);
    }
  }

  public getReportingYear(): void {
    if (this.reportingYearsService.selectedYear) {
      this.getTabDetails(this.reportingYearsService.selectedYear);
    }
    this.reportingYearsService.selectedYearSubject.subscribe((value) => {
      this.getTabDetails(value);
    });
  }

  public getTabDetails(year) {
    this.selectedReportingCycleYear = year;
    if (this.currentReportingCycleYear !== year) {
     this.disableButton = true;
    } else {
     this.disableButton = false;
    }
  }

}
